import { useHttpList } from '@/composable/service/useHttp';
import { useFormatDate } from '@/composable/ui/useDate';
import useAsyncState from '@/composable/service/useAsyncState';
import shopHttp from '@/services/http/shop.http';
import { onMounted } from 'vue';
import analyticHttp from '@/services/http/analytic.http';

export default function useGetShopsByEncodedId(encodedId: string) {
  const shopHtp = useHttpList(shopHttp.getFcShopTempoDetail);
  const decodeShopHttp = useHttpList(analyticHttp.decodeFcShopId);
  const asyncState = useAsyncState(shopHtp.request);

  onMounted(async () => {
    if (encodedId) {
      const decodeShopRes = await decodeShopHttp.request({ encodedId });
      await asyncState.request({ id: decodeShopRes.decodedId });
    }
  });

  return {
    decodedShop: asyncState.data,
    shopLoading: asyncState.loading,
    shopError: asyncState.error,
  };
}
